module.exports = __webpack_public_path__ + "static/Beach-Final-8d6d35c5ed0b72215be5c0fba1d1e4b7.mp4";